export default {"src":"https://images-cdn-staging.curipod.com/d-8d80375e/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};